<template>
  <div
    data-testid="media-library-banner"
    class="media-library-banner"
  >
    <img
      :src="getStaticAssetUrl('/images/account/account-products/generated-banner-1.jpg')"
      width="127px"
      height="84px"
      class="media-library-banner__image"
    >
    <div class="media-library-banner__content">
      <div
        class="media-library-banner__title"
        data-testid="title"
      >
        {{ t('brand.account.mediaLibrary.banner.title') }}
      </div>
      <AkParagraph>
        {{ t('brand.account.mediaLibrary.banner.content') }}
      </AkParagraph>
    </div>
  </div>
</template>

<script setup lang="ts">
import { AkParagraph } from '@ankorstore/design-system';
import { getStaticAssetUrl } from '@modules/shared/util/img-cdn/img-cdn';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.media-library-banner {
  @apply ds-flex ds-items-center ds-p-4 ds-text-primary ds-bg-white ds-mb-4 ds-border ds-border-neutral-300 ds-border-solid ds-shadow-sm;
}
.media-library-banner__image {
  @apply ds-flex-none ds-mr-5 ds-hidden md:ds-block;
}
.media-library-banner__content {
  @apply ds-flex-1;
}
.media-library-banner__title {
  @apply ds-text-xl ds-text-primary ds-font-bold ds-mb-1;
}
</style>
